import { styled } from '@mui/material/styles';
import { Button } from '../../Button';
import { Image } from '../../Image';

export const ButtonStyled = styled(Button)`
  margin-bottom: 4px;
`;

export const ImageStyled = styled(Image)`
  border-radius: inherit;
  object-fit: cover;
`;
